import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { submitDeleteEntry } from '../actionCreators/submitDeleteEntry';
import PHPURL from '../reducers/ReducerPHPURL';
import RomanianPackage from '../languages/RomanianPackage';
import { setCellData } from '../actionCreators/setCellData';
import { submitCellUpdate } from '../actionCreators/submitCellUpdate';
import { toggleForm } from '../actionCreators/toggleForm';
import { setFormData } from '../actionCreators/setFormData';
import { selectOption } from '../actionCreators/selectOption';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import './CellBuilder.css';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class CellBuilder extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            readOnly: true,
            class: 'readOnlyCell'
        }

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnDoubleClick = this.handleOnDoubleClick.bind(this);
        this.transformEntry = this.transformEntry.bind(this);
        this.deleteEntry = this.deleteEntry.bind(this);
        this.viewContract = this.viewContract.bind(this);
        this.generateCertificate = this.generateCertificate.bind(this);
        this.confirmEntry = this.confirmEntry.bind(this);
        this.closeActivity = this.closeActivity.bind(this);
    }

    handleOnChange(e) {

        if (e.target.type === 'checkbox') {

            e.target.value = e.target.checked === true ? '1' : '0';
            this.handleOnBlur(e);
        }
        if(this.props.isSubComponent){
            this.props.setCellData(this.props.subTable, this.props.index, this.props.column, e.target.value);
        }
        else {
            this.props.setCellData(this.props.table, this.props.index, this.props.column, e.target.value);
        }   
    }

    handleOnBlur(e) {

        if (!this.state.readOnly || e.target.type === 'checkbox') {

            let updateData = {
                table: this.props.view.updateTable,
                field: this.props.column,
                value: e.target.value,
                Nr_Crt: this.props.data[this.props.index].Nr_Crt
            }

            updateData = JSON.stringify(updateData);

            this.props.submitCellUpdate(updateData, this.props.view, this.props.phpFile);

            this.setState({
                readOnly: true,
                class: 'readOnlyCell'
            });
        }
    }

    handleOnDoubleClick(e) {

        this.setState({
            readOnly: false,
            class: 'editableCell'
        });

    }

    transformEntry() {

        this.props.toggleForm(true);

        Object.keys(this.props.data[this.props.index]).forEach(key => {

            this.props.view.formLabels.forEach(obj => {

                if (obj.Field === key) {

                    let e = {
                        target: {
                            name: key,
                            value: this.props.data[this.props.index][key]
                        }
                    };
                    this.props.setFormData(e);
                }
            })
        })

    }

    deleteEntry() {

        let deleteData = { Nr_Crt: this.props.data[this.props.index].Nr_Crt, table: this.props.view.insertTable };
        let deleteURL = PHPURL.baseURL + PHPURL.deleteData;

        deleteData = JSON.stringify(deleteData);

        this.props.submitDeleteEntry(deleteURL, deleteData, this.props.view, this.props.phpFile);
    }

    generateCertificate() {

        let phpPath = PHPURL.baseURL + PHPURL.getCertificateData + this.props.data[this.props.index].Numar_contract;

        Promise.all([
            fetch(phpPath)
                .then(data => data.json()),
            this.imageToBase64('antetheader.jpg'),
            this.imageToBase64('antetfooter.jpg')
        ])
            .then((values) => { this.generatePDF(values[0], values[1], values[2]) })
    }

    confirmEntry() {
        let updateData = {
            table: this.props.view.updateTable,
            field: this.props.column,
            value: 'Da',
            Nr_Crt: this.props.data[this.props.index].Nr_Crt
        }

        updateData = JSON.stringify(updateData);

        this.props.submitCellUpdate(updateData, this.props.view, this.props.phpFile);
    }

    closeActivity() {
        let updateData = {
            table: 'Activitati',
            field: 'Inchis',
            value: 'Da',
            Nr_Crt: this.props.data[this.props.index].Nr_Crt
        }

        updateData = JSON.stringify(updateData);

        this.props.submitCellUpdate(updateData, this.props.view);
    }

    generatePDF(data, header, footer) {
        var certificatePDF = {
            content: [
                {
                    image: header,
                    fit: [595, 210],
                    margin: [0, -40, 0, 0],
                    alignment: 'center'
                },

                '\n', '\n',

                {
                    text: 'Nr:.........../' + data.date,
                    alignment: 'right',
                    margin: [0, 0, 30, 0]
                },

                '\n', '\n',

                {
                    text: 'Adeverinta',
                    alignment: 'center',
                    fontSize: 30,
                    margin: [0, 30, 0, 0]
                },

                '\n', '\n', '\n', '\n',

                {
                    columns: [
                        { text: '', width: '*' },
                        {
                            text: `Se adevereste prin prezenta ca ` + data.volunteer + ` este voluntar al Societatii Nationale de Cruce Rosie din Romania - Filiala Sector 6 Bucuresti din data de ` + data.signing_date +  ` si a participat ca voluntar la proiectele desfasurate de catre filiala noastra in domeniile: ` + data.activities + ` totalizand un numar de ` + data.total + ` ore. \n \n S-a eliberat prezenta pentru a-i servi la completarea dosarului personal.`,
                            width: 595,
                            margin: [30, 0, 100, 0]
                        },
                        { text: '', width: '*' },
                    ],
                },

                '\n', '\n', '\n', '\n',

                {
                    alignment: 'center',
                    columns: [
                        {
                            text: 'Data',
                            margin: [30, 0, 0, 0],
                            alignment: 'left'
                        },
                        {
                            text: 'Director',
                            margin: [0, 0, 30, 0],
                            alignment: 'right',
                        }
                    ],
                },
                {
                    alignment: 'center',
                    columns: [
                        {
                            text: data.date,
                            margin: [30, 0, 0, 0],
                            alignment: 'left'
                        },
                        {
                            text: 'Derumeaux Ana',
                            margin: [0, 0, 30, 0],
                            alignment: 'right',
                        }
                    ],
                }
            ],

            footer: {
                image: footer,
                alignment: 'center',
                fit: [595, 135],
                margin: [0, -50, 0, 0]
            }
        }

        pdfMake.createPdf(certificatePDF).open();
    }

    imageToBase64(img) {

        return new Promise((resolve, reject) => {
            const image = new Image();

            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };

            image.onerror = () => {
                reject(new Error('Could not load image'));
            };

            image.crossOrigin = 'Anonymous';
            image.src = PHPURL.baseURL + 'media/' + img;
        });
    }

    viewContract() {
        window.open(PHPURL.baseURL + 'contracts/' + this.props.data[this.props.index].Numar_contract + '.pdf');
    }

    render() {

        if (this.props.column === "Stergere") {

            return (
                <button
                    onClick={this.deleteEntry}
                >
                    {RomanianPackage.DELETE}
                </button>
            )
        }

        if (this.props.column === "Aprobat" && this.props.data[this.props.index]['Aprobat'] !== 'Da') {
            return (
                <button
                    onClick={this.confirmEntry}
                >
                    {RomanianPackage.VALIDATE_PRESENCE}
                </button>
            )
        }

        if (this.props.column === "Inchidere") {
            return (
                <button
                    onClick={this.closeActivity}
                >
                    {RomanianPackage.CLOSE_ACTIVITY}
                </button>
            )
        }

        if (this.props.column === "Transformare") {

            return (
                <button
                    onClick={this.transformEntry}
                >
                    {RomanianPackage.TRANSFORM_INTO_VOLUNTEER}
                </button>
            )
        }

        if (this.props.column === "Adeverinta") {
            return (
                <button
                    onClick={this.generateCertificate}
                >
                    {RomanianPackage.GENERATE}
                </button>
            )
        }

        if (this.props.column === "Scan_contract") {

            return (
                <button
                    onClick={this.viewContract}
                >
                    {RomanianPackage.VIEW}
                </button>
            )
        }

        if (this.props.type === "checkbox") {

            return (
                <input
                    type="checkbox"
                    checked={this.props.data[this.props.index][this.props.column] === '1' ? true : false}
                    onChange={this.handleOnChange}
                />
            )
        }

        else {
            return (
                <input
                    value={this.props.data[this.props.index][this.props.column]}
                    type={this.props.type}
                    readOnly={this.state.readOnly}
                    onChange={this.props.editable === '1' ? this.handleOnChange : null}
                    onBlur={this.props.editable === '1' ? this.handleOnBlur : null}
                    onDoubleClick={this.props.editable === '1' ? this.handleOnDoubleClick : null}
                    className={this.state.class}
                />
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        view: state.activeOption,
        table: state.table,
        subTable: state.subTable,
        hideForm: state.hideForm,
        formData: state.formData
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        submitDeleteEntry: submitDeleteEntry,
        setCellData: setCellData,
        submitCellUpdate: submitCellUpdate,
        toggleForm: toggleForm,
        setFormData: setFormData,
        selectOption: selectOption
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CellBuilder);


// WEBPACK FOOTER //
// ./src/tableBuilder/CellBuilder.js